import React from 'react';

export const ExternalLinkIcon: React.FC = () => (
    <svg
        width='14'
        height='14'
        viewBox='252.5 362 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            d='M263 369.583V373.083C263 373.393 262.877 373.689 262.658 373.908C262.439 374.127 262.143 374.25 261.833 374.25H255.417C255.107 374.25 254.811 374.127 254.592 373.908C254.373 373.689 254.25 373.393 254.25 373.083V366.667C254.25 366.357 254.373 366.061 254.592 365.842C254.811 365.623 255.107 365.5 255.417 365.5H258.917'
            stroke='currentColor'
            strokeWidth='1.16667'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M261.25 363.75H264.75V367.25'
            stroke='currentColor'
            strokeWidth='1.16667'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M258.333 370.167L264.75 363.75'
            stroke='currentColor'
            strokeWidth='1.16667'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
    </svg>
);
